<template>
  <div>
    <!-- 广告名称 -->
    <div v-if="formKey === 'campaign_name' && !formItem.isPreview">
      <el-link v-for="word in formItem.word_list" :key="word" class="mr-10" :underline="false" type="primary" @click="insertWord(`{${word}}`, formItem)">+{{ word }}</el-link>
    </div>
    <!-- 素材标签 -->
    <div v-if="formKey === 'labels'">
      <div>
        <div class="flex items-center">
          <el-button v-if="!formItem.isPreview" type="primary" @click="() => openAssignLabels(formItem)">选择素材标签</el-button>
          <div v-if="!Object.keys(formItem.value || {}).length && formItem.isPreview">-</div>
          <div v-if="Object.keys(formItem.value || {}).length && formItem.isPreview">
            <div v-for="(item, adv_id) in formItem.value" :key="adv_id">
              <div v-for="i in item" :key="i.id">
                <span class="mr-20">{{ adv_id }}</span>
                <span class="mr-20">{{ i.label_id || '-' }}</span>
                <span>{{ i.name || '-' }}</span>
              </div>
            </div>
          </div>
          <i v-if="Object.keys(formItem.value || {}).length && !formItem.isPreview" class="el-icon-success app-check-icon-success ml-10" />
        </div>
        <el-dialog
          title="素材标签配置"
          :visible.sync="formItem.is_open"
          :close-on-click-modal="false"
          :append-to-body="true"
          :modal-append-to-body="true"
          width="800px"
        >
          <labels :key="Date.now()" :form-item="formItem" />
          <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="formItem.is_open = false">取 消</el-button>
            <el-button size="mini" type="primary" @click="() => confirmAssignLabels(formItem)">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { component_props } from '@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/model/props';
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';

export default {
  components: {
    'labels': () => import('./components/labels/index.vue'),
  },
  mixins: [data_sharing_mixin],
  props: {
    ...component_props,
  },
  methods: {
    /**
     * 插入通配符
     * @param word 通配符
     * @param form_item 表单项
     */
    insertWord(word, form_item) {
      const name = form_item.value;
      const match_list = name.match(/{[^}{]*?}/g) || [];
      form_item.value = match_list.includes(word) ? name.replace(word, '') : name.concat(word);
    },
    /**
     * 打开素材标签配置
     * @param form_item 表单项
     * @returns {void}
     */
    openAssignLabels(form_item) {
      form_item.assignSelection = JSON.parse(JSON.stringify(form_item.value));
      form_item.is_open = true;
    },
    /**
     * 素材标签配置弹窗确认
     * @param form_item 表单项
     * @returns {void}
     */
    confirmAssignLabels(form_item) {
      const result = JSON.parse(JSON.stringify(form_item.assignSelection));
      const { config: { init_ops: { advertiser_ids }}} = this.local_sharing_data.getFormContext();
      const is_valid = advertiser_ids.every(advertiser_id => result[advertiser_id]?.length);
      if (is_valid) {
        form_item.value = JSON.parse(JSON.stringify(form_item.assignSelection));
        form_item.is_open = false;
        form_item?.on?.change?.(form_item.value);
        this.$parent.$parent.$parent.validateField('labels.value');
      } else {
        this.$message.warning('请填写完整所有配置');
      }
    },
  },
};
</script>
